import { EventBusEventEnum } from '../enums/EventBusEventEnum';

export default class EventBus {
  static emit(eventName: EventBusEventEnum, data: any): void {
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
  }

  static on(eventName: EventBusEventEnum, handler: (data: any) => void): void {
    window.addEventListener(eventName, (event: Event) => {
      const customEvent = event as CustomEvent;
      if (customEvent.detail) {
        handler(customEvent.detail);
      }
    });
  }

  static off(eventName: EventBusEventEnum, handler: (data: any) => void): void {
    window.removeEventListener(eventName, handler);
  }
}
